import BigNumber from 'bignumber.js';

import { ContractsManager } from 'modules/core';
import { api, cacheTags } from 'modules/store';

export interface IsLowBalancePopupParams {
  accountAddress: string;
  USDAccountBalance: BigNumber | null;
}

const MIN_BALANCE_IN_USD = new BigNumber(100);

export const { useIsLowBalancePopupQuery } = api.injectEndpoints({
  endpoints: build => ({
    isLowBalancePopup: build.query<boolean, IsLowBalancePopupParams>({
      queryFn: async ({ accountAddress, USDAccountBalance }) => {
        if (!USDAccountBalance || !accountAddress) {
          return { data: false };
        }

        if (!USDAccountBalance.isLessThan(MIN_BALANCE_IN_USD)) {
          return { data: false };
        }

        const sdk = await ContractsManager.getInstance();
        const registry = await sdk.getRegistryContract();

        const taskIds = await registry.methods.userTasks(accountAddress).call();
        if (!taskIds?.length) {
          return { data: false };
        }

        for (let i = 0; i < taskIds.length; i++) {
          // TODO: https://ankrnetwork.atlassian.net/browse/AUTO-138
          // eslint-disable-next-line no-await-in-loop
          const { isPaused } = await registry.methods
            .getTask(taskIds[i])
            .call();

          if (!isPaused) {
            return { data: true };
          }
        }

        return { data: false };
      },
      providesTags: [cacheTags.taskData, cacheTags.account],
    }),
  }),
});
